import(/* webpackMode: "eager", webpackExports: ["PageHero"] */ "/var/www/one/components/platform/v2/PageEdge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Section"] */ "/var/www/one/components/platform/v2/Section.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/one/node_modules/next/dist/client/app-dir/link.js");
